import { useMemo } from 'react';
import { Form, Formik, FormikValues } from 'formik';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import {
  Button,
  Accordion,
  Typography,
  AccordionDetails,
  AccordionSummary,
} from '@mui/material';

import { getDataForFormikFormFromFields } from 'utils/form';
import { DynamicFormFields } from 'components/dynamic-form-fields';

import { FormPreviewProps } from '../types';

export const FormPreview = ({
  blocks,
  title = 'Preview',
}: FormPreviewProps) => {
  const formikProps = useMemo(
    () => getDataForFormikFormFromFields(blocks.map((b) => b.fields).flat()),
    [blocks]
  );

  return (
    <>
      <Typography variant="h5">{title}</Typography>

      <Formik<FormikValues> onSubmit={() => {}} {...formikProps}>
        {({ submitForm }) => (
          <Form className="flex w-full flex-col gap-4">
            {blocks.map((block) => (
              <Accordion key={block.id} defaultExpanded>
                <AccordionSummary expandIcon={<ArrowDownwardIcon />}>
                  <Typography>{block.name || 'Section'}</Typography>
                </AccordionSummary>
                <AccordionDetails className="flex flex-col gap-4">
                  <DynamicFormFields fields={block.fields} />
                </AccordionDetails>
              </Accordion>
            ))}

            <Button type="submit" variant="contained" onClick={submitForm}>
              Validate
            </Button>
          </Form>
        )}
      </Formik>
    </>
  );
};
